// extracted by mini-css-extract-plugin
module.exports = {"light":"brand_light__z08Oh","dark":"brand_dark__b93Y2"};